export enum GachaHistoriesEnum {
  POST_GACHA = "/gacha-histories",
  GET_GACHA_DETAIL = "/gacha-histories/:id",
  EXCHANGE_CARDS_TO_POINT = "/exchange-histories",
  GET_PACK_NUMBER_ROLL_USER = "/gacha-histories/pack-number-roll-user",
}
